import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { map, Observable, Subject, Subscription } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import {
  ActionMode,
  ActionModeType,
  ButtonColor,
  ButtonIconColor,
  ButtonModel,
  ButtonOption,
  ButtonType,
  DataBroadcast,
  EntityOnboardFieldModel,
  EntityOnboardFormDataModel,
  EntityOnboardPayloadModel,
  EntityOnboardModel,
  EntityOnboardSectionModel,
  EntityOnboardStateModel,
  EntityType,
  EntityValue,
  FormField,
  FormFieldInput,
  EntityOnboardResponseModel,
  EntityOnboardDataPayloadModel,
  EntityOnboardDataModel,
  SelectBoxModel,
  EntityOnboardApiConfigModel,
  UnknownModel,
  ResponseModelV3,
  DialogModel,
  EntityPage,
  EntityListPayloadModel
} from 'src/app/model';
import { FileTypeService } from 'src/app/modules/knowledge-base/services';
import { DataService, ServicecallService } from 'src/app/services';
import { CamelcasePipe } from 'src/app/shared/pipe';
import { DialogService, FormService, GeneralService } from 'src/app/shared/services';
import { ChassisNumberValidator, ImageUrlValidator, ImeiValidator } from 'src/app/shared/validator';
import { EntityBulkUploadComponent } from '../entity-bulk-upload/entity-bulk-upload.component';

@Component({
  selector: 'app-entity-onboard',
  templateUrl: './entity-onboard.component.html',
  styleUrl: './entity-onboard.component.scss'
})
export class EntityOnboardComponent implements OnInit, OnDestroy {

  @Input()
  set content(value: EntityOnboardModel) {
    this._content = value;
    //Sets the modal type
    this._setRouteState();
    // Set form fields based on configuration
    this._setFormSection(value?.formField);
    // Update form value & validity
    this._formService?.updateFormValueAndValidity(this.form);
    // Set page title
    this._setPageTitle(value?.entityType);
    // Get form data, if the formStatus is UPDATE
    this._getFormData();
  }

  get content() {
    return this._content;
  }

  @Output() formValues = new EventEmitter<EntityOnboardPayloadModel>();
  @Output() onDialogClose = new EventEmitter<any>();

  // Content
  pageTitle: string;
  pageSubTitle: string;
  public _content: EntityOnboardModel;
  public bulkEnable : boolean;
  errorMessage: boolean = false;
  tenantConfig: any;

   //File Upload
   fileName: string;
   file = new FormControl();
   public fileContent: any;
   fileMimeTypes = [
     "image/jpeg",
     "image/png",
     "image/svg+xml",
   ];
   maxFileSize: number;
   isUploadFormSubmitted: boolean = false;
   startFileBlobUpload: boolean = false;
   private _blobResponse: any = {
     file: null
   };
   private _isAllFilesSelected: boolean = false;
   private _fileSelectedCount = 0;
   private _fileUploadedCount = 0;
   private readonly _TWO = 10;
   private _updateCaseSubscription: Subscription;
   private _fetchPresignedUrlSubscription: Subscription;
   selecetdEntity: any;
   image: string;

   //AWS S3 File upload
   preSignedUrl: string;

  // Form
  form: FormGroup;
  isFormSubmitted: boolean = false;
  formActionList: ButtonModel[] = [
    {
      label: Messages?.BUTTON_LABEL_CANCEL,
      type: ButtonType?.BUTTON,
      color: ButtonColor.SECONDARY,
      action: ActionMode?.CANCEL
    },
    {
      label: Messages?.BUTTON_LABEL_SUBMIT,
      type: ButtonType?.SUBMIT,
      color: ButtonColor.PRIMARY,
      action: ActionMode?.ADD
    },
    {
      label: Messages?.BUTTON_LABEL_UPDATE,
      type: ButtonType?.SUBMIT,
      color: ButtonColor.PRIMARY,
      action: ActionMode?.UPDATE
    }
  ];
  formStatus: ActionModeType;

  // Button
  backButton: ButtonModel = {
    type: ButtonType.BUTTON,
    option: ButtonOption.ICON,
    label: Messages?.BUTTON_LABEL_BACK,
    color: ButtonColor.TRANSPARENT,
    icon: 'icon-entity-onboard-back.svg',
    iconColor: ButtonIconColor.ACTUAL
  };

  // Router
  _routerState: EntityOnboardStateModel;

  // Subscription
  private _createEntitySubscription: Subscription;
  private _updateEntitySubscription: Subscription;
  private _getEntitySubscription: Subscription;
  private _fieldOptionSubscription: Subscription;
  private _formActionDialogSubscription: Subscription;

  // Miscellaneous
  readonly MESSAGES = Messages;
  readonly FORM_FIELD = FormField;
  readonly FORM_FIELD_INPUT = FormFieldInput;
  readonly BUTTON_TYPE = ButtonType;
  readonly ACTION_MODE = ActionMode;

  constructor(
    public generalService: GeneralService,
    private _formBuilder: FormBuilder,
    private _formService: FormService,
    private _apiService: ServicecallService,
    private _router: Router,
    private _dataService: DataService,
    private _camelcasePipe: CamelcasePipe,
    private _dialogService: DialogService,
    private _generalService: GeneralService,
    private _dialog: MatDialog,
    private _fileTypeService: FileTypeService
  ) {
    this.tenantConfig = this._apiService.getConfiguration('tenantGenericConfig') ?? null;
    this._setRouteState();
    // Create form
    this._createForm();
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this._createEntitySubscription?.unsubscribe();
    this._updateEntitySubscription?.unsubscribe();
    this._getEntitySubscription?.unsubscribe();
    this._fieldOptionSubscription?.unsubscribe();
    this._formActionDialogSubscription?.unsubscribe();
    this._fetchPresignedUrlSubscription?.unsubscribe();
  }

  ngOnChanges() {
    this.file?.reset();
    this.fileName = null;
    this._setFileContent();
  }

  /**
   * Determines whether back button click on
   */
  onBackButtonClick() {
    // Redirect to appropriate entity listing page
    if(this._content?.modalType === 'dtcDrilldown') {
      this.onDialogClose.emit(true);
    } else {
      this._router.navigate([this.content?.path ?? this.content?.pageType]);
    }
  }

  /**
   * Determines whether form action click on
   * @param event
   * @param buttonContent
   */
  onFormActionClick(event: MouseEvent, buttonContent: ButtonModel) {
    switch (buttonContent?.action) {
      case ActionMode.CANCEL:
        if(this._content?.modalType === 'dtcDrilldown') {
          this.onDialogClose.emit(true);
        } else {
          // Redirect to appropriate entity listing page
          this._router.navigate([this.content?.path ?? this.content?.pageType]);
        }
        break;
      default:
        this._onFormAction();
        break;
    }
  }

  /**
  * Gets form group by control key
  * @param parentFormGroup
  * @param formContolKey
  * @returns form group by control key
  */
  getFormGroupByControlKey(parentFormGroup: FormGroup, formContolKey: string): FormGroup {
    return parentFormGroup?.controls?.[this.transformControlKey(formContolKey)] as FormGroup;
  }

  /**
   * Transforms control key
   * @param controlKey
   * @returns control key
   */
  transformControlKey(controlKey: string): string {
    return this._camelcasePipe.transform(controlKey);
  }

  /**
   * Gets field validations
   * @param formControl 
   * @param sectionKey 
   * @param formGroupName 
   * @returns  
   */
   getFieldValidations(path: string[]) {
    return this.getControl(path)?.errors ?? null;
  }

  /**
   * Gets flattened fields
   * @param fields 
   * @param formField 
   * @param [parentPath] 
   * @param [sectionKey] 
   * @returns  
   */
  getFlattenedFields(
    fields: EntityOnboardFieldModel[],
    parentPath: string[] = [],
    sectionKey?: string ) {
    for (const field of fields) {
      const currentPath = [...parentPath, field.key];
      const fullPath = sectionKey ? [sectionKey, ...currentPath] : currentPath;
  
      field.path = fullPath;
      if (field.children?.length) {
        this.getFlattenedFields(field.children, currentPath, sectionKey);
      }
    }
  }
  
   /**
    * Gets selected option
    * @param path 
    * @param options 
    * @returns  
    */
   getSelectedOption(path: string[], options: { name: string, value: string }[]) {
    const control = this.getControl(path);
    const value = control?.value;
  
    return options?.find(option => option?.value === value) ?? null;
  }
  

  /**
   * Determines whether virtual scroll value selection on
   * @param path 
   * @param options 
   * @returns  
   */
  onVirtualScrollValueSelection(path, options: { name: string, value: string }) {
    if (!path?.length) return;

    const control = this.getControl(path);
    if (control) {
      control.setValue(options?.value);
      control.markAsDirty();
    }
  }

  /**
   * Gets control
   * @param path 
   * @returns control 
   */
  getControl(path: string[]) {
    return path?.reduce((acc: AbstractControl | null, key: string) => {
      return acc instanceof FormGroup ? acc?.get(key) : null;
    }, this.form);
  }

  private _setFileContent() {
    this.fileContent = {
      file: {
        fileUrl: this.file?.value,
        fileName: this.fileName,
        fileSize: null,
        fileType: this._fileTypeService.getFileExtensionFromUrl(this.file?.value)
      }
    }
  }

  uploadResponse(event: any, formControlName: string) {
    this._blobResponse[formControlName] = event;
    if (event?.stage === 'upload') {
      this._updateFileUploadedCount(event?.status, false);
      if (event?.fileUrl) {
        this.file?.patchValue(event?.fileUrl);
      }
      this.fileName = null;
      this.file?.reset();
      this.startFileBlobUpload = false;
      if (this.fileSelectedCount === this._fileUploadedCount) {
        this._setFileContent();
      }
    } else if (event?.stage === 'select') {
      this._updateFileSelectedCount(event?.status);
    } else if (event?.stage === 'exist-delete') {
      this._updateFileSelectedCount(!event?.status);
      this._updateFileUploadedCount(!event?.status);
    } else if (event?.stage === 'soft-delete') {
      this._updateFileSelectedCount(!event?.status);
      this.startFileBlobUpload = false;
    }
  }

  get fileSelectedCount() {
    return this._fileSelectedCount;
  }

  set fileSelectedCount(value: number) {
    this._fileSelectedCount = value;
    this._isAllFilesSelected = this.fileSelectedCount === this._TWO ? true : false;
  }

  private _updateFileSelectedCount(condition: boolean | string, hasDecrement: boolean = true) {
    condition ? this.fileSelectedCount++ : (hasDecrement ? this.fileSelectedCount-- : this.fileSelectedCount);
  }

  private _updateFileUploadedCount(condition: boolean | string, hasDecrement: boolean = true) {
    condition ? this._fileUploadedCount++ : (hasDecrement ? this._fileUploadedCount-- : this._fileUploadedCount);
  }

  onFormSubmit(path: string[]) {
    this.isUploadFormSubmitted = true;
    if (!this.file?.value) {
      return;
    }
    if(!(this.form?.get(path?.[0]))?.get('uniqueId')?.value) {
      this.errorMessage = true;
      return;
    }
    this.errorMessage = false;
    const dateTime = new DatePipe('en-US').transform(
      Date.now(),
      'YYYYMMddHHmmssSSSS'
    );
    const blobName = (this.form?.get(path?.[0]))?.get('uniqueId')?.value + '_' + dateTime + '.' + this.file?.value?.name?.split('.')?.pop();
    const currentFile: File = this.file?.value;
    const renamedFile = new File([currentFile], blobName, {
    type: currentFile?.type,
    });
    this.file.setValue(renamedFile);
    const formData = new FormData();
    if (this.file) {
      formData?.append('file', this.file?.value);
      formData?.append('directory', 'face/' + localStorage?.getItem('domain') + '/images/');
    }
    // Form status check
    this._apiService.fetchPreSignedUrl(formData)?.subscribe({
      next: (result: {url: string, fileName: string}) => {
        if(result?.url) {
          this.startFileBlobUpload = false;
          this.preSignedUrl = result?.url;
          this.getControl(path)?.setValue(this.preSignedUrl);
          this.getControl(path)?.markAsDirty();
          this._apiService?.toasterService({ type: 'success', msg: Messages.SUCCESS });
        }
      }
    });
  }

  onClearImage(path: string[]) {
    const control = this.getControl(path);
    if (control) {
      control.setValue(null);
      control.markAsDirty();
    }
    this.image = null;
    this.file?.reset();
    this.fileName = null;
    this._setFileContent();
  }

  downLoadFile(url: string, fileName: string) {
    window.open(url, "_blank");
  }

  /**
   * Creates form
   */
  private _createForm() {
    this.form = this._formBuilder.group({});
  }

  /**
   * Sets form section
   * @param sectionList
   */
  private _setFormSection(sectionList: EntityOnboardSectionModel[]) {
    sectionList?.map(
      (sectionContent: EntityOnboardSectionModel) => {
        const formControlKey = this.transformControlKey(sectionContent?.sectionKey);
        this.form?.addControl(
          formControlKey,
          this._formBuilder.group({})
        );
        this._setFormField(
          this.form?.controls?.[formControlKey] as FormGroup<any>,
          sectionContent?.fields,
          sectionContent?.sectionKey
        );
      }
    );
  }

  /**
   * Sets form field
   * @param formGroup
   * @param fieldList
   */
  private _setFormField(formGroup: FormGroup<any>, fieldList: EntityOnboardFieldModel[], sectionKey: string) {
    if (formGroup && fieldList?.length) {
      fieldList?.map(
        (fieldContent: EntityOnboardFieldModel) => {
          const formControlKey = this.transformControlKey(fieldContent?.key);
          if (fieldContent?.children?.length) {
            // Add cpntrol as formArray
            formGroup?.addControl(
              formControlKey,
              this._formBuilder.group({})
            );
            this._setFormField(
              formGroup?.controls?.[formControlKey] as FormGroup<any>,
              fieldContent?.children,
              sectionKey
            );
          } else {
            // Default value
            let fieldDefaultValue = fieldContent?.defaultValue;
            // Set default value from application
            switch (fieldContent?.defaultValue) {
              case '[ENTITY_TYPE]':
                fieldDefaultValue = this.content?.entityType;
                break;
            }
            // Set validator list
            const validatorList = this._getValidatorList(fieldContent);
            // Add field to section form
            formGroup?.addControl(
              formControlKey,
              this._formBuilder.control(
                { value: fieldDefaultValue ?? null, disabled: !!fieldContent?.disabled },
                validatorList
              )
            );
            // Set form field as dirty for field with default value
            if (fieldContent?.hasOwnProperty('defaultValue') && !fieldContent?.children?.length) {
              this._formService?.setFieldDirtyOrPristine(formGroup, formControlKey, true);
            }
            // Set options, if optionType is API
            if (fieldContent?.optionType && fieldContent?.apiConfig) {
              this._getFieldOptionList(fieldContent?.apiConfig)
                ?.subscribe({
                  next: (result: SelectBoxModel[]) => {
                    fieldContent.options = result;
                  }
                });
            }
          }
        }
      );
      this.getFlattenedFields(fieldList,[],sectionKey)
    }
  }

  /**
   * Determines whether form action on
   * @returns
   */
  private _onFormAction() {
    this._formService?.updateFormValueAndValidity(this.form);
    this.isFormSubmitted = true;
    if (this.form.invalid) {
      return;
    }

    // Call form actions based on formStatus
    if (this.formStatus === ActionMode?.ADD) {
      this._saveFormData();
    } else if (this.formStatus === ActionMode?.UPDATE) {
      this._updateFormData();
    }
  }

  /**
   * Saves form data
   */
  private _saveFormData() {
    // Set value of field which has fetchValuekey
    this._setFetchValueKey();
    // Set payload content
    const payloadContent = this._setPayloadContent();
    if (this._content?.entityType === EntityValue.ALERTPROFILE) {
      this.formValues?.emit(payloadContent)
    } else {
      if (this._content?.entityType !== EntityValue.DTC) {
        this._createEntitySubscription = this._apiService.createEntity(Array.of(payloadContent))
          .subscribe({
            next: (result: EntityOnboardResponseModel[]) => {
              const [entityResult] = result;
              // Set dialog
              this._setFormActionDialog(entityResult, payloadContent, 'add');
            }
          });
      }  else {
        this.formValues?.emit(payloadContent)
      }
    }
  }

  /**
   * Updates form data
   */
  private _updateFormData() {
    const payloadContent = this._setPayloadContent(true);
    if(this._content?.entityType !== EntityValue.DTC && this.content.pageType !== EntityPage.ALERTPROFILE) {
      this._updateEntitySubscription = this._apiService.updateEntity(payloadContent)
      .subscribe({
        next: (result: EntityOnboardResponseModel[]) => {
          const entityResult = result;
          // Set dialog
          this._setFormActionDialog(entityResult, payloadContent, 'edit');
        }
      });
    } else {
      this.formValues?.emit(payloadContent);
    }
  }

  /**
   * Sets payload content
   * @returns payload content
   */
  private _setPayloadContent(overrideDirtyCheck: boolean = false): EntityOnboardPayloadModel {
    let formPayloadContent: EntityOnboardFormDataModel = this._getFormValueList(this.form, overrideDirtyCheck);
    return {
      siteId: sessionStorage.getItem('siteId') ? JSON.parse(sessionStorage.getItem('siteId') || '{}') : null,
      ...formPayloadContent
    } as EntityOnboardPayloadModel;
  }

  /**
   * Sets fetch value key
   */
  private _setFetchValueKey() {
    this.content?.formField?.forEach(
      (formSection) => {
        const formControlKey = this.transformControlKey(formSection?.sectionKey);
        this._setFetchValueKeyField(
          formSection?.fields,
          this.form?.controls?.[formControlKey] as FormGroup<any>
        );
      }
    );
  }

  /**
   * Sets fetch value key field
   * @param fields
   * @param formGroup 
   */
  private _setFetchValueKeyField(fields: EntityOnboardFieldModel[], formGroup: FormGroup<any>) {
    if (formGroup && fields?.length) {
      const fieldList = fields?.filter((field) => field?.fetchValuekey);
      fieldList?.forEach(
        (fieldContent: EntityOnboardFieldModel) => {
          const formControlKey = this.transformControlKey(fieldContent?.key);
          const fetchValueKey = this.transformControlKey(fieldContent?.fetchValuekey);
          let fetchValueControl = formGroup?.controls?.[fetchValueKey];
          this._formService?.setFormValues(
            formGroup,
            {
              [formControlKey]: fetchValueControl?.value
            }
          );
          if (fieldContent?.children?.length) {
            this._setFetchValueKeyField(
              fieldContent?.children,
              formGroup?.controls?.[formControlKey] as FormGroup<any>
            );
          }
        }
      );
    }
  }

  /**
   * Gets form value list
   * @param form
   * @returns form value list
   */
  private _getFormValueList(form: FormGroup, overrideDirtyCheck: boolean = false): EntityOnboardFormDataModel {
    return Object.keys(form?.controls)?.reduce(
      (accumulator: EntityOnboardFormDataModel, formControlName) => {
        let currentFormControl = form?.controls?.[formControlName];
        if (currentFormControl.dirty || overrideDirtyCheck) {
          return {
            ...accumulator,
            [formControlName]: (currentFormControl instanceof FormGroup)
              ? this._getFormValueList(currentFormControl as FormGroup, overrideDirtyCheck)
              : currentFormControl?.value
          }
        } else {
          return {
            ...accumulator
          };
        }
      }, {} as EntityOnboardFormDataModel
    );
  }

  /**
   * Sets route state
   */
  private _setRouteState() {
    this._routerState = <EntityOnboardStateModel>history?.state;
    this.formStatus = this._routerState?.formStatus ?? this._content?.formStatus;
  }

  /**
   * Gets form data
   */
  private _getFormData() {
    if (this._routerState?.entityId) {
        const payloadContent: Partial<EntityListPayloadModel> = {
          status: true,
          searchKey: null,
          sortBy: null,
          filterBy: null,
          operationalStatusFilter: null,
          alertsFilter: null,
          siteId: this._apiService.getSiteId(),
          type: 1,
          domain: this.tenantConfig?.tenant,
          entityIds: [this._routerState?.entityId]
        };
        this._getEntitySubscription = this._apiService?.entitiesList(payloadContent, 1, false)?.subscribe({
          next: (result: any) => {
            if (result['status'] && result['response']['data']?.length) {
              const entity = result['response']?.['data']?.[0];
              const entityResult = {entity: entity  };
              this._loadDataToForm(entityResult);
            }
          }, error: () => {
            this._apiService.toasterService({ type: 'error', msg: 'Error' });
          }
        })
    } else if ((this._content.modalType === 'dtcDrilldown' || this.content.pageType === EntityPage.ALERTPROFILE) && this._content.data) {
      this._loadDataToForm(this._content.data)
    } 
  }

  /**
   * Loads data to form
   * @param formContentGroup
   */
  private _loadDataToForm(formContent: EntityOnboardDataModel) {

    this._ensureDropdownOptionsIncludeValues(formContent);
    // Set form values and update all form fields as Pristine
    this._formService?.setFormValues(this.form, formContent, false);
    // Mark the entire form as pristine (untouched state)
    this.form?.markAsPristine();
    this.form?.markAsUntouched();

    // Recursively mark all controls as pristine
    this._markFormGroupPristine(this.form);
    this.image = formContent?.['entity']?.image ?? null;
    if(this.image && this._routerState?.entityId) {
      this.fetchPresignedUrl(formContent?.['entity']?.image);
    }
  }

  /**
   * Recursively marks all form controls as pristine
   * @param formGroup 
   */
  private _markFormGroupPristine(formGroup: FormGroup) {
    Object.keys(formGroup?.controls)?.forEach(key => {
      const control = formGroup?.get(key);

      if (control instanceof FormGroup) {
        // Recursively handle nested form groups
        this._markFormGroupPristine(control);
      } else {
        // Mark individual control as pristine
        control?.markAsPristine();
        control?.markAsUntouched();
      }
    });
  }

  /**
  * Checks if the submit button should be disabled
  * @returns true if button should be disabled
  */
  isSubmitDisabled(): boolean {
    // For UPDATE mode, disable if form is pristine (untouched) or invalid
    if (this.formStatus === ActionMode.UPDATE) {
      return this.form.pristine || (this.isFormSubmitted && this.form.invalid);
    }

    return false;
  }

  fetchPresignedUrl(url: string) {
    const payload = { urls: [url] };
    this._fetchPresignedUrlSubscription = this._apiService?.getPresignedUrls(payload)?.subscribe({
      next: (result) => {
        if(result?.urls?.[0]) {
          this.image = result?.urls?.[0]?.presignedUrl;
        } else {
          this._apiService?.toasterService({ type: 'error', msg: Messages.ERROR_PRESIGNED_URL });
        }
      }, error() {
        this._apiService?.toasterService({ type: 'error', msg: Messages.ERROR_PRESIGNED_URL });
      }
    });  
  }

  /**
 * Ensures dropdown options include the values from form content
 * @param formContent 
 */
  private _ensureDropdownOptionsIncludeValues(formContent: EntityOnboardDataModel) {
    if (!this.content?.formField || !formContent) {
      return;
    }

    this.content.formField?.forEach(section => {
      this._processFieldsForDropdownValues(section?.fields, formContent, [section?.sectionKey]);
    });
  }

  /**
 * Recursively processes fields to ensure dropdown options include form values
 * @param fields 
 * @param formContent 
 * @param pathArray 
 */
  private _processFieldsForDropdownValues(
    fields: EntityOnboardFieldModel[], 
    formContent: EntityOnboardDataModel, 
    pathArray: string[]
  ) {
    if (!fields) return;

    fields?.forEach(field => {
      const currentPath = [...pathArray, field?.key];

      if (field.fieldType === 'DROP_DOWN' || field.fieldType === 'SEARCH_DROP_DOWN') {
        this._ensureDropdownOptionExists(field, formContent, currentPath);
      }

      if (field?.children && field?.children?.length > 0) {
        this._processFieldsForDropdownValues(field?.children, formContent, currentPath);
      }
    });
  }

  /**
 * Ensures a dropdown option exists for the given value
 * @param field 
 * @param formContent 
 * @param pathArray 
 */
  private _ensureDropdownOptionExists(
    field: EntityOnboardFieldModel, 
    formContent: EntityOnboardDataModel, 
    pathArray: string[]
  ) {
    const value = this._getValueFromPath(formContent, pathArray);

    if (value === null || value === undefined || value === '') {
      return;
    }

    if (!field.options) {
      field.options = [];
    }

    const existingOption = field?.options?.find(option => option?.value === value);

    if (!existingOption) {
      const newOption: SelectBoxModel = {
        name: value,
        value: value
      };

      field?.options?.push(newOption);
    }
  }

  /**
   * Gets value from formContent using a path array
   * @param obj 
   * @param pathArray 
   * @returns 
   */
   private _getValueFromPath(obj: any, pathArray: string[]): any {
    return pathArray?.reduce((current, key) => {
      return current && typeof current === 'object' ? current[key] : undefined;
    }, obj);
  }


  /**
   * Sets page title
   * @param entityType
   */
  private _setPageTitle(entityType: EntityType) {
    // Set button label
    let pageTitle: string = Messages.ENTITY_ONBOARD_TITLE
      ?.replace(
        '[STATUS]',
        (this.formStatus === ActionMode?.ADD)
          ? Messages.TEXT_ADD
          : Messages.TEXT_EDIT
      );
    let pageSubTitle: string = Messages.ENTITY_ONBOARD_SUBTITLE
    ?.replace(
      '[STATUS]',
      (this.formStatus === ActionMode?.ADD)
        ? Messages.TEXT_ADD?.toLowerCase()
        : Messages.TEXT_EDIT?.toLowerCase()
    );
    // Set button label based on entityType
    this.pageTitle = this._replaceEntityType(pageTitle, entityType);
    this.pageSubTitle = this._replaceEntityType(pageSubTitle, entityType, true);
  }

  /**
   * Replaces entity type
   * @param message
   * @param entityType
   * @returns entity type
   */
  private _replaceEntityType(message: string, entityType: EntityType, isLowercase: boolean = false): string {
    switch (entityType) {
      case EntityValue.ASSET:
        message = message
          ?.replace('[ENTITY_NAME]', isLowercase ? Messages.TEXT_ENTITY_ASSET?.toLowerCase() : Messages.TEXT_ENTITY_ASSET)
        break;

      case EntityValue.VEHICLE:
        message = message
          ?.replace('[ENTITY_NAME]', isLowercase ? Messages.TEXT_ENTITY_VEHICLE?.toLowerCase() : Messages.TEXT_ENTITY_VEHICLE)
        break;

      case EntityValue.PEOPLE:
        message = message
          ?.replace('[ENTITY_NAME]', isLowercase ? Messages.TEXT_ENTITY_PEOPLE?.toLowerCase() : Messages.TEXT_ENTITY_PEOPLE)
        break;
      case EntityValue.DTC:
        message = message
          ?.replace('[ENTITY_NAME]', isLowercase ? Messages.TEXT_DTC?.toLowerCase() : Messages.TEXT_DTC)
        break;
      case EntityValue.ALERTPROFILE:
        message = message
          ?.replace('[ENTITY_NAME]', isLowercase ? Messages.TEXT_ALERTPROFILE?.toLowerCase() : Messages.TEXT_ALERTPROFILE)
        break;
    }
    return message;
  }

  /**
   * Gets validator list
   * @param fieldContent
   * @returns validator list
   */
  private _getValidatorList(fieldContent: EntityOnboardFieldModel): ValidatorFn[] {
    let validatorList: ValidatorFn[] = [];
    // Set mandatory validator based on visibility
    if (fieldContent?.visible && fieldContent?.mandatory) {
      validatorList?.push(Validators.required);
    }
    // Set Custom validation
    if (fieldContent?.validation) {
      switch (fieldContent?.validation) {
        case "IMEI":
          validatorList?.push(ImeiValidator);
          break;

        case "IMAGE_URL":
          validatorList?.push(ImageUrlValidator);
          break;

        case "CHASSIS_NUMBER":
          validatorList?.push(ChassisNumberValidator);
          break;
      }
    }
    return validatorList?.length ? validatorList : null;
  }

  /**
   * Gets field option list
   * @param [apiConfig]
   * @returns field option list
   */
  private _getFieldOptionList(apiConfig?: EntityOnboardApiConfigModel): Observable<SelectBoxModel[]> {
    const optionList = new Subject<SelectBoxModel[]>();
    if (apiConfig) {
      const payloadContent: UnknownModel = this._getFieldOptionPayloadContent(apiConfig);
      this._fieldOptionSubscription = this._apiService.getFormFieldOption(
        apiConfig?.endpoint,
        apiConfig?.method,
        payloadContent
      )
      .subscribe({
        next: (result: ResponseModelV3<UnknownModel[]>) => {
          // Add option list
          optionList?.next(
            result?.response?.data?.map(
              (data: UnknownModel) => {
                return {
                  name: data?.[apiConfig?.responseMap?.value],
                  value: data?.[apiConfig?.responseMap?.key]
                } as SelectBoxModel;
              }
            ) ?? [] as SelectBoxModel[]
          );
        }
      });
    }
    return optionList;
  }

  /**
   * Gets field option payload
   * @param [apiConfig]
   * @returns field option payload
   */
  private _getFieldOptionPayloadContent(apiConfig?: EntityOnboardApiConfigModel): UnknownModel {
    let payloadContent: UnknownModel = {};
    apiConfig?.payload?.forEach(
      (payloadName) => {
        switch (payloadName) {
          case 'SITE_ID':
            payloadContent['siteId'] = sessionStorage.getItem('siteId')
              ? JSON.parse(sessionStorage.getItem('siteId') || '{}')
              : null;
            break;
        }
      }
    );
    return payloadContent;
  }

  /**
   * Generates response message
   * @param key
   * @param payload
   * @returns response message
   */
  private _generateResponseMessage(key: string, payload: EntityOnboardPayloadModel): string {
    let returnMessage: string = null;
    if (this.content?.formResponse?.[key]) {
      const regExp = /\[(.*?)\]/g;
      returnMessage = this.content?.formResponse?.[key];
      const matchList = [...returnMessage.matchAll(regExp)];
      matchList?.forEach(
        (matchContent) => {
          // Get replace value
          const matchContentList = matchContent?.[1]?.split('.');
          let replaceValue: string = this._generalService?.getDescendantProp({...payload}, matchContent?.[1], '.');
          // Find option list to fetch display value
          const optionList = this._getSectionBykey(this.content?.formField, matchContentList);
          replaceValue = optionList?.length
            ? optionList?.find((option) => option?.value === replaceValue)?.name
            : replaceValue;
          // Replace value in appropriate message
          returnMessage = returnMessage?.replace(matchContent?.[0], replaceValue);
        }
      );
    }
    return returnMessage;
  }

  /**
   * Sets form action dialog
   * @param result
   * @param payloadContent
   */
  private _setFormActionDialog(result: EntityOnboardResponseModel, payloadContent: EntityOnboardPayloadModel, type: string) {
    let dialogConfig: MatDialogConfig<DialogModel> = {} as MatDialogConfig<DialogModel>;
    // Dialog config
    if (result?.errors?.length) {
      dialogConfig = {
        data: {
          title: Messages?.ENTITY_ONBOARD_DIALOG_ERROR_TITLE,
          content: result?.errors?.[0],
          actions: []
        }
      };
    } else {
      const successMessage: string = this._generateResponseMessage(type === 'edit' ? 'editSuccessMessage' : 'successMessage', payloadContent);
      dialogConfig = {
        data: {
          title: Messages?.ENTITY_ONBOARD_DIALOG_SUCCESS_TITLE,
          content: successMessage,
          actions: [
            {
              label: Messages?.BUTTON_LABEL_CLOSE,
              type: ButtonType?.BUTTON,
              value: true,
              color: ButtonColor.PRIMARY
            }
          ],
          showClose: false
        }
      };
    }
    this._formActionDialogSubscription = this._dialogService
      ?.showDialog(dialogConfig)
      ?.afterClosed()
      ?.subscribe({
        next: (response: boolean) => {
          if (response) {
            this._dataService.broadcast(DataBroadcast.API_REFRESH);
            // Redirect to appropriate entity listing page
            this._router.navigate([this.content?.pageType]);
          }
        }
      });
  }

  /**
   * Gets section bykey
   * @param sectionList
   * @param keyList
   * @returns section bykey
   */
  private _getSectionBykey(sectionList: EntityOnboardSectionModel[], keyList: string[], level: number = 0): SelectBoxModel[] {
    let optionList: SelectBoxModel[] = [] as SelectBoxModel[];
    if (keyList?.[level]) {
      const fieldList = sectionList?.find((sectionContent) => sectionContent?.sectionKey === keyList?.[level])?.fields;
      optionList = this._getFieldBykey(fieldList, keyList, level + 1, optionList);
    }
    return optionList;
  }

  /**
   * Gets field bykey
   * @param fieldList
   * @param keyList
   * @param level
   * @returns field bykey
   */
  private _getFieldBykey(fieldList: EntityOnboardFieldModel[], keyList: string[], level: number, optionList: SelectBoxModel[]): SelectBoxModel[] {
    if (keyList?.[level]) {
      const fieldListTemp = fieldList?.find((fieldContent) => fieldContent?.key === keyList?.[level]);
      optionList = fieldListTemp?.options;
      this._getFieldBykey(fieldListTemp?.children, keyList, level + 1, optionList);
    }
    return optionList;
  }

  /**
   * To bulk upload data
   */
  public onBulkUpload() {
    const dialogRef = this._dialog.open(EntityBulkUploadComponent, {
      width: '40%',
      data: { title: this._content?.bulkUploadTitle, subtitle: this._content?.bulkUploadSubtitle, apiType : this.content?.apiType, inventoryApiType: this._content?.inventoryApiType },
      panelClass: 'custom-bulk-dialog',
      disableClose: true
    });
  }
}
